import { TICKET_PRIORITY, ISSUE_TYPE } from "@/types/enum/general"

class FeedbackTicket {
    constructor(
        public name: string = '',
        public description: string = '',
        public status: string = '',
        public priority: TICKET_PRIORITY = TICKET_PRIORITY.MEDIUM,
        public type: ISSUE_TYPE
    ) {
    }
}

class FeedbackTicketTemplate {
    constructor(
        public issue: string = '',
        public place: string = '',
        public expectation: string = '',
        public steps: string = '',
        public date: string = '',
        public osVersion: string = '',
        public webVersion: string = '',
        public deviceId: string = '',
        public deviceModel: string = '',
        public binaryVersion: string = '',
        public webViewVersion: string = ''
    ) {
    }
}

export {
    FeedbackTicket,
    FeedbackTicketTemplate
}
